import { useCallback, useState } from "react"
import { useTranslation } from "react-i18next";
import useApi from "../../../utils/api";
import { getErrorMessage } from "../../../utils/helpers/errors";

export const useBatchJobsApi = () => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);

    const { authGet } = useApi();

    const get = useCallback(async (controller) => {
        setLoading(true);
        try {
            const response = await authGet("/schedules/bulk-jobs", { signal: controller.signal });
            if (response) {
                setData(response.result);
                setTotalItems(response.totalItems);
            }
        } catch (err) {
            getErrorMessage(err, t);
        } finally {
            setLoading(false);
        }
    }, [authGet, t]);

    return { get, data, loading, totalItems };
}